module.exports = __webpack_public_path__ + "static/media/Alfa Romeo.bd1889d8.jpeg";